import { Switch, SwitchProps, ToggleButton, ToggleButtonGroup } from '@chronosphereio/chrono-ui';
import { DisplayOption, PieChartVisualOptions } from '@/core';
import { OptionsEditorControl, OptionsEditorGroup } from '@/plugin-editor-components';
import { ColorPaletteSelector } from '@/plugin-editor-components/components/ColorPaletteSelector';
import { DEFAULT_COLOR_PALETTE, DEFAULT_DISPLAY } from './pie-chart-model';

export interface VisualOptionsEditorProps {
  value: PieChartVisualOptions;
  onChange: (visual: PieChartVisualOptions) => void;
}

export function VisualOptionsEditor(props: VisualOptionsEditorProps) {
  const { onChange, value } = props;

  const handleDisplayChange = (event: React.MouseEvent, display: DisplayOption): void => {
    onChange({
      ...value,
      display,
    });
  };

  const handleShowSeriesLegendChange: SwitchProps['onChange'] = (_: unknown, checked: boolean) => {
    onChange({
      ...value,
      show_series_name: checked,
    });
  };

  return (
    <OptionsEditorGroup title="Visual">
      <OptionsEditorControl
        label="Display"
        control={
          <ToggleButtonGroup value={value.display ?? DEFAULT_DISPLAY} onChange={handleDisplayChange}>
            <ToggleButton aria-label="default display" value="Default">
              Default
            </ToggleButton>
            <ToggleButton aria-label="donut display" value="Donut">
              Donut
            </ToggleButton>
          </ToggleButtonGroup>
        }
      />
      <OptionsEditorControl
        label="Show series name"
        control={<Switch checked={value.show_series_name !== false} onChange={handleShowSeriesLegendChange} />}
      />
      <ColorPaletteSelector
        value={value.color_palette ?? DEFAULT_COLOR_PALETTE}
        onChange={(newPalette) =>
          onChange({
            ...value,
            color_palette: newPalette,
          })
        }
      />
    </OptionsEditorGroup>
  );
}
